import {DataSourceInterface} from './datasource.interface.mjs';
import * as lib from "@mecatran/urbiplan-services-lib"

var {UrbiplanApiLib, UrbiplanApiConfig, urbiplanApiModel} = lib;

console.log('lib',lib);
console.log('urbiplanApiModel',urbiplanApiModel)


/**
 * @param urbiplanApiConfig is a object instance of UrbiplanApiConfig 
 */
export class UrbiplanApiDataSource extends DataSourceInterface{
    constructor(urbiplanApiConfig){
        super();
        if (urbiplanApiConfig.constructor !== UrbiplanApiConfig) throw new Error('UrbiplanApiDataSource. Incorrect type')
        var _lib = new UrbiplanApiLib();
        _lib.setConfig(urbiplanApiConfig);

        Object.defineProperty(this,'lib',{
            get : function(){ return _lib },
            enumerable : false
        })


    }
    getTypedObject(){
        console.log('get')
        /*
        return this.lib.alerts().then((urbiplanApi)=>{
            console.log('urbiplanApi:',urbiplanApi);
            return urbiplanApi.getAlerts()
        })
        */
        return this.lib.stops().then((urbiplanApi)=>urbiplanApi.getStops())  // returns promise on  UrbiplanApi
    }



}